module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-position": "left",
      "label-width": "120px"
    }
  }, [_c('div', {
    staticClass: "section-body"
  }, [_c('el-form-item', {
    attrs: {
      "label": "社区拼团商城客服"
    }
  }, [_c('el-switch', {
    attrs: {
      "width": 50,
      "active-value": "true",
      "inactive-value": "false",
      "active-text": "开启",
      "inactive-text": "关闭",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.form.customer_switch),
      callback: function($$v) {
        _vm.$set(_vm.form, "customer_switch", $$v)
      },
      expression: "form.customer_switch"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支持支付宝提现"
    }
  }, [_c('el-switch', {
    attrs: {
      "width": 50,
      "active-value": "true",
      "inactive-value": "false",
      "active-text": "开启",
      "inactive-text": "关闭",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.form.withdraw_bank.alipay),
      callback: function($$v) {
        _vm.$set(_vm.form.withdraw_bank, "alipay", $$v)
      },
      expression: "form.withdraw_bank.alipay"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支持微信提现"
    }
  }, [_c('el-switch', {
    attrs: {
      "width": 50,
      "active-value": "true",
      "inactive-value": "false",
      "active-text": "开启",
      "inactive-text": "关闭",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.form.withdraw_bank.wechatpay),
      callback: function($$v) {
        _vm.$set(_vm.form.withdraw_bank, "wechatpay", $$v)
      },
      expression: "form.withdraw_bank.wechatpay"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "支持银行卡提现"
    }
  }, [_c('el-switch', {
    attrs: {
      "width": 50,
      "active-value": "true",
      "inactive-value": "false",
      "active-text": "开启",
      "inactive-text": "关闭",
      "active-color": "#13ce66"
    },
    model: {
      value: (_vm.form.withdraw_bank.bankpay),
      callback: function($$v) {
        _vm.$set(_vm.form.withdraw_bank, "bankpay", $$v)
      },
      expression: "form.withdraw_bank.bankpay"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "积分兑换比例"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "required": "",
      "min": "1",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.community_config.point_ratio),
      callback: function($$v) {
        _vm.$set(_vm.form.community_config, "point_ratio", $$v)
      },
      expression: "form.community_config.point_ratio"
    }
  }), _vm._v(" 积分兑换1元人民币\n      ")], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "积分说明"
    }
  }, [_c('vue-html5-editor', {
    ref: "editor",
    attrs: {
      "content": _vm.form.community_config.point_desc,
      "height": 260
    },
    on: {
      "change": _vm.updatePointDescContent
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "积分提现说明"
    }
  }, [_c('vue-html5-editor', {
    ref: "editor",
    attrs: {
      "content": _vm.form.community_config.withdraw_desc,
      "height": 260
    },
    on: {
      "change": _vm.updateWithdrawDescContent
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "客服电话"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "240px"
    },
    attrs: {
      "type": "number",
      "required": "",
      "min": "1",
      "placeholder": ""
    },
    model: {
      value: (_vm.form.consumer_hotline),
      callback: function($$v) {
        _vm.$set(_vm.form, "consumer_hotline", $$v)
      },
      expression: "form.consumer_hotline"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "section-footer with-border content-center"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保 存")])], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-003853fd", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-003853fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/promotions/community/setting.vue
// module id = 2418
// module chunks = 0